import React, { createContext, useState, useContext } from 'react';
import axios from '../axios';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem('token'));

  const login = async (email, password) => {
    const res = await axios.post('/login', { email, password });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('permission', res.data.user.permission);
    setToken(res.data.token);
    navigate('/folders');
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);